module.exports = __webpack_public_path__ + "img/hr-tree-01-d-trunk.61ffb66a.png";